export default "/images/34c08719026ce308a6f640d61201c9cb.avif";